import React from "react";
import {
  DialogContent,
  Grid,
  Card,
  Box,
  Typography,
  DialogActions,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";

import ButtonCommon from "../../../../../components/buttons/ButtonCommon";
import DialogCommonDefault from "../../../../../components/dialogs/DialogCommonDefault";
import { CustomTheme } from "../../../../../types/customTheme";
import { handleImageUrl } from "../../../../../utils/ChangePixelImgUrl";

const useStyles = makeStyles((theme: any) =>
  createStyles({
    imgBoxStyle: {
      margin: "7px 0 7px 10px",
      borderRadius: "10px",
      height: "120px",
      [theme.breakpoints.down("sm")]: { height: "92px" },
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    imgBoxNotAvailableStyle: {
      margin: "10px 7px 10px 10px",
      borderRadius: "10px",
      height: "114px",
      width: "114px",
      [theme.breakpoints.down("sm")]: { height: "80px", width: "80px" },
      backgroundColor: theme.palette.background.imgBackground,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    img: {
      objectFit: "cover",
      width: "114px",
      height: "114px",
      [theme.breakpoints.down("sm")]: { width: "88px", height: "84px" },
      borderRadius: "10px",
      border: `1px solid ${theme.palette.background.entity_border}`,
    },
    titleStyle: {
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      [theme.breakpoints.down("sm")]: { "-webkit-line-clamp": 1 },
    },
    boxStyle: {
      display: "-webkit-box",
      "-webkit-line-clamp": 3,
      "-webkit-box-orient": "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textTransform: "capitalize",
    },
  }),
);

interface ItemModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  itemNode: any[];
  selectedWrapperIdList: any;
  img: string | null;
  setSelectedWrapperIdList: (data: any) => void;
  itemId: any;
  keys: number[];
}

const ItemModal: React.FC<ItemModalProps> = ({
  isOpen,
  setIsOpen,
  itemNode,
  selectedWrapperIdList,
  img,
  setSelectedWrapperIdList,
  keys,
}) => {
  const classes = useStyles();
  const theme: CustomTheme = useTheme();

  const handleItemClick = (item: any) => {
    const clone = { ...selectedWrapperIdList };
    const wrapperId = item.itemWrapperId;
    const itemId = item.id;

    // Handle undefined wrapper selection
    if (clone.undefined?.[itemId]) {
      delete clone.undefined[itemId];
      if (Object.keys(clone.undefined).length === 0) delete clone.undefined;
      setSelectedWrapperIdList(clone);
      return;
    }

    // Toggle item selection
    if (clone[wrapperId]?.[itemId]) {
      delete clone[wrapperId][itemId];
      if (Object.keys(clone[wrapperId]).length === 0) delete clone[wrapperId];
    } else {
      clone[wrapperId] = clone[wrapperId] || {};
      clone[wrapperId][itemId] = {
        memberId: itemId,
        memberType: "ITEM",
        wrapperId,
      };
    }

    setSelectedWrapperIdList(clone);
  };

  const getCardBackgroundColor = (item: any) => {
    if (item?.valid === false) return theme.palette.custom.red.main;
    return keys.includes(Number(item.id))
      ? theme.palette.custom.blue.main
      : theme.palette.background.entity_background;
  };

  return (
    <DialogCommonDefault
      open={isOpen}
      setOpen={() => setIsOpen(false)}
      isNeedFixedHeight
      maxWidth="xl"
    >
      <DialogContent>
        <Grid container spacing={2}>
          {itemNode.map((item) => (
            <Grid
              key={item.id}
              item
              md={6}
              xs={12}
              lg={4}
              style={{ marginTop: 4 }}
            >
              <div
                style={{ overflow: "hidden", zIndex: 0 }}
                onClick={() => handleItemClick(item)}
              >
                <Card
                  style={{
                    cursor: "pointer",
                    borderRadius: 10,
                    border: `1px solid ${theme.palette.background.entity_border}`,
                    boxShadow: "none",
                    zIndex: 0,
                    backgroundColor: getCardBackgroundColor(item),
                  }}
                >
                  <Grid container>
                    <Grid item xs={12} style={{ display: "flex" }}>
                      {img ? (
                        <Box className={classes.imgBoxStyle}>
                          <img
                            src={handleImageUrl(img)}
                            alt="Item"
                            className={classes.img}
                          />
                        </Box>
                      ) : (
                        <Box className={classes.imgBoxNotAvailableStyle}>
                          <ImageOutlinedIcon style={{ fontSize: 52 }} />
                        </Box>
                      )}
                      <Grid
                        item
                        xs
                        container
                        direction="column"
                        style={{ paddingLeft: 8 }}
                      >
                        <Typography
                          className={classes.titleStyle}
                          style={{
                            fontWeight: "bold",
                            color: item?.valid === false ? "white" : undefined,
                            paddingTop: 4,
                          }}
                        >
                          {`${item?.name} - ${item?.size}`}
                        </Typography>
                        <Typography
                          className={classes.boxStyle}
                          variant="body2"
                          style={{
                            textTransform: "lowercase",
                            color: item?.valid === false ? "white" : undefined,
                          }}
                        >
                          {item?.desc}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </div>
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions>
        <ButtonCommon
          variant="contained"
          style={{ fontSize: 11, marginLeft: 4, width: 100, height: 32 }}
          onClick={() => setIsOpen(false)}
        >
          Done
        </ButtonCommon>
      </DialogActions>
    </DialogCommonDefault>
  );
};

export default ItemModal;
